import { system } from './system-core.esm.js';
import { memoizedGet } from '../utils/object.esm.js';
import { resolveSizeValue } from '../utils/size-utils.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var defaults = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var getFontSize = function getFontSize(n, scale, props) {
  var v = resolveSizeValue(props.theme || props)(n, 'sizes.font');
  return memoizedGet(scale, v, v);
};
var config = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    transform: getFontSize,
    defaultScale: defaults.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config);

export default typography;
export { getFontSize, typography };
//# sourceMappingURL=typography.esm.js.map
